import { z } from "zod";

export default z
  .object({
    al: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("Al content <0, 9.99> [wt%]"),
    b: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("B content <0, 9.99> [wt%]"),
    c: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("C content <0, 9.99> [wt%]"),
    cr: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("Cr content <0, 9.99> [wt%]"),
    cu: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("Cu content <0, 9.99> [wt%]"),
    mn: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("Mn content <0, 9.99> [wt%]"),
    mo: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("Mo content <0, 9.99> [wt%]"),
    ni: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("Ni content <0, 9.99> [wt%]"),
    p: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("P content <0, 9.99> [wt%]"),
    s: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("S content <0, 9.99> [wt%]"),
    si: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("Si content <0, 9.99> [wt%]"),
    ti: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("Ti content <0, 9.99> [wt%]"),
    v: z
      .number()
      .multipleOf(0.001)
      .gte(0)
      .lte(9.99)
      .describe("V content <0, 9.99> [wt%]"),
  })
  .describe("Material composition");
